import React from 'react';
import { motion } from 'framer-motion';
import { SectionLabel, SectionHeading, SecondaryButton } from './ui/UI';
export function FrontierGatewayTeaser() {
  return <section className="relative w-full py-32 border-t border-white/5" data-id="element-596">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-597">
        <SectionLabel number="03" label="Frontier Gateway" className="mb-8" data-id="element-598" />

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-16" data-id="element-599">
          <div className="lg:col-span-7" data-id="element-600">
            <SectionHeading size="xl" data-id="element-601">
              Frontier cyber models
              <br data-id="element-602" />
              <span className="text-white/40" data-id="element-603">need guardrails.</span>
            </SectionHeading>
          </div>
          <div className="lg:col-span-5 lg:pt-4" data-id="element-604">
            <p className="text-lg text-white/60 leading-relaxed mb-6" data-id="element-605">
              Periscan Frontier Gateway, now in alpha, is a control layer for
              safely connecting frontier cyber models to approved validation
              tools without giving models direct network access.
            </p>
            <p className="text-lg text-white/60 leading-relaxed mb-6" data-id="element-606">
              Models can analyze context and propose actions. Periscan governs
              scope, tools, approvals, redaction, execution, audit, and
              evidence.
            </p>
            <SecondaryButton href="#" size="md" data-id="element-607">
              Coming Soon
            </SecondaryButton>
          </div>
        </div>

        <div className="border-t border-white/5 mb-16" data-id="element-608">
          {[{
          title: 'No direct network access.'
        }, {
          title: 'No arbitrary shell.'
        }, {
          title: 'No unsupervised actions.'
        }, {
          title: 'Every action audited.'
        }].map((feature, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: i * 0.05
        }} className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-8 py-6 border-b border-white/5 last:border-0" data-id="element-609">
              <div className="md:col-span-1" data-id="element-610">
                <span className="font-mono text-xs text-[#1a8fd4]/60" data-id="element-611">
                  {String(i + 1).padStart(2, '0')}
                </span>
              </div>
              <div className="md:col-span-11" data-id="element-612">
                <h3 className="text-lg font-semibold text-white tracking-tight" data-id="element-613">
                  {feature.title}
                </h3>
              </div>
            </motion.div>)}
        </div>

        <div className="max-w-3xl" data-id="element-614">
          <p className="text-sm text-white/40 leading-relaxed" data-id="element-615">
            Anthropic says Project Glasswing was created because Claude Mythos
            Preview showed capabilities that could reshape cybersecurity, and
            OpenAI describes Trusted Access for Cyber as vetted access to
            advanced cyber capabilities for defenders.
          </p>
        </div>
      </div>
    </section>;
}